import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { Consumer } from '@rails/actioncable';

export type State = {
  state: string;
  comment: string | null;
};

const UserToUserTransferState: FC<{
  transferId: string;
  locales: Record<string, string>;
  processingImageUrl: string;
}> = ({ transferId, locales, processingImageUrl }) => {
  const [state, setState] = useState<State>({ state: 'unknown', comment: null });

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription = cable.subscriptions.create(
      {
        channel: 'UserToUserTransferStateChannel',
        transfer_id: transferId,
      },
      {
        connected: () => {
          subscription.perform('send_state');
        },
        received: (data: State) => {
          setState(data);
        },
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  if (['failed', 'success'].includes(state.state))
    return (
      <div>
        <h2 className="title">{locales[state.state]}</h2>
        <span>{state.comment}</span>
      </div>
    );

  return (
    <div>
      <h2 className="title">{locales.processing}</h2>
      <img alt="processing" src={processingImageUrl} />
    </div>
  );
};

export default UserToUserTransferState;
